import { render } from "./AffiliationAnnouncementModal.vue?vue&type=template&id=3bd2145c&scoped=true"
import script from "./AffiliationAnnouncementModal.vue?vue&type=script&lang=js"
export * from "./AffiliationAnnouncementModal.vue?vue&type=script&lang=js"

import "./AffiliationAnnouncementModal.vue?vue&type=style&index=0&id=3bd2145c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd2145c"]])

export default __exports__